import React from 'react';
import ProductItemView from '../ProductItemViewMobile';
import sample_management from '../../resource/lis_mobile/sample_management.png';


const SampleManagementMobile = () => {
    return (
        <ProductItemView
            title="Gestión de las muestras"
            items={["Derivaciones a laboratorios externos e internos", "Distribución y seguimiento", "Almacenamiento multi sede"]}
            image={sample_management} />
    );
};

export default SampleManagementMobile;